import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import styles from "./Profile.module.scss";
import { BsPencilSquare } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { getClinicInfo, resetUpdateAccountMessages } from "../../../store/slices/clinicSlice";
import { updateAccountInfo } from "../../../store/slices/clinicSlice";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";

const Account = () => {
  const dispatch = useDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const { clinicInfo, updateAccountErrorMessage, updateAccountSuccessMessage } = useSelector(
    (state) => state.clinic
  );
  const { token, userInfo } = useSelector((state) => state.auth);
  const clinic = clinicInfo && clinicInfo.length > 0 ? clinicInfo[0] : [];
  const [clinicAccountFormData, setClinicAccountFormData] = useState({
    gst: "",
    accountEmail: "",
    dlNumber: "",
    drugsBazaarId: "",
    pan: "",
    fssaiLicenseNumber: "",
  });

  useEffect(() => {
    if (updateAccountSuccessMessage) {
      showToastifySuccess(updateAccountSuccessMessage);
      dispatch(resetUpdateAccountMessages());
    }
    if (updateAccountErrorMessage) {
      showToastifyError(updateAccountErrorMessage);
      dispatch(resetUpdateAccountMessages());
    }
  }, [dispatch, updateAccountErrorMessage, updateAccountSuccessMessage]);

  const handleEdit = (item) => {
    setIsEditing((prevState) => !prevState);
    if (!isEditing) {
      setClinicAccountFormData({
        gst: item?.accountInfo?.gst,
        accountEmail: item?.accountInfo?.accountEmail,
        dlNumber: item?.accountInfo?.dlNumber,
        drugsBazaarId: item?.accountInfo?.drugsBazaarId,
        pan: item?.accountInfo?.pan,
        fssaiLicenseNumber: item?.accountInfo?.fssaiLicenseNumber,
      });
    }
  };

  const handleChange = (e) => {
    setClinicAccountFormData({
      ...clinicAccountFormData,
      [e.target.name]: e.target.value,
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const data = {
      clinicId: clinic?._id,
      ...clinicAccountFormData,
      token
    };
    await dispatch(updateAccountInfo(data)).unwrap();
    await dispatch(getClinicInfo({ userId: userInfo?._id, token }));
    setIsEditing(false);
  };
  return (
    <>
      <Row>
        <Col md={5} className={styles["account-col"]}>
          <div className={styles["input-div"]}>
            <label className="col-form-label"><h5>Account Email :</h5></label>
            {isEditing ? (
              <input
                type="text"
                name="accountEmail"
                value={clinicAccountFormData?.accountEmail}
                onChange={handleChange}
                className="form-control"
              />
            ) : (
              <p>{clinic?.accountInfo?.accountEmail || "NA"}</p>
            )}

          </div>
        </Col>
        <Col md={5} className={styles["account-col"]}>
          <div className={styles["input-div"]}>
            <label className="col-form-label"><h5>GST :</h5></label>
            {isEditing ? (
              <input
                type="text"
                name="gst"
                value={clinicAccountFormData?.gst}
                onChange={handleChange}
                className="form-control"
              />
            ) : (
              <p>{clinic?.accountInfo?.gst || "NA"}</p>
            )}
          </div>
        </Col>
        <Col md={2}>
          <div className={styles["edit-btn"]}>
            <BsPencilSquare onClick={() => handleEdit(clinic)} />
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={5} className={styles["account-col"]}>
          <div className={styles["input-div"]}>
            <label className="col-form-label"><h5>DL Number (Drug License Number) :</h5></label>
            {isEditing ? (
              <input
                type="text"
                name="dlNumber"
                value={clinicAccountFormData?.dlNumber}
                onChange={handleChange}
                className="form-control"
              />
            ) : (
              <p>{clinic?.accountInfo?.dlNumber || "NA"}</p>
            )}
          </div>
        </Col>
        <Col md={5} className={styles["account-col"]}>
          <div className={styles["input-div"]}>
            <label className="col-form-label"><h5>Drugs Bazaar ID :</h5></label>
            {isEditing ? (
              <input
                type="text"
                name="drugsBazaarId"
                value={clinicAccountFormData?.drugsBazaarId}
                onChange={handleChange}
                className="form-control"
              />
            ) : (
              <p>{clinic?.accountInfo?.drugsBazaarId || "NA"}</p>
            )}
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={5} className={styles["account-col"]}>
          <div className={styles["input-div"]}>
            <label className="col-form-label"><h5>PAN (Permanent Account Number) :</h5></label>
            {isEditing ? (
              <input
                type="text"
                name="pan"
                value={clinicAccountFormData?.pan}
                onChange={handleChange}
                className="form-control"
              />
            ) : (
              <p>{clinic?.accountInfo?.pan || "NA"}</p>
            )}
          </div>
        </Col>
        <Col md={5} className={styles["account-col"]}>
          <div className={styles["input-div"]}>
            <label className="col-form-label"><h5>FSSAI License Number :</h5></label>
            {isEditing ? (
              <input
                type="text"
                name="fssaiLicenseNumber"
                value={clinicAccountFormData?.fssaiLicenseNumber}
                onChange={handleChange}
                className="form-control"
              />
            ) : (
              <p>{clinic?.accountInfo?.fssaiLicenseNumber || "NA"}</p>
            )}
          </div>
        </Col>
      </Row>
      <div className="text-end mt-5">
        <Button className="p-2" onClick={handleUpdate}>
          Update
        </Button>
      </div>
    </>
  );
};

export default Account;
